<template>
  <div
    class="btn btn-sm ps-2"
    data-bs-toggle="popover"
    data-bs-placement="bottom"
    data-bs-html="true"
    data-bs-trigger="click"
    :title="title"
    :data-bs-content="content"
  >
    <i class="fa fa-info-circle" aria-hidden="true"></i>
  </div>
</template>

<script setup>

const props = defineProps({
    title: {
        type: String,
        default: "",
    },
    content: {
        type: String,
        default: "",
    },
});

</script>

<style scoped>
.btn {
  cursor: pointer;
}
</style>
